/*
 * Created on Thu Oct 12 2023 10:24:59 AM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc.
 * Possession, use, duplication or dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import validator from "validator";
import NumberFormat from "react-number-format";
import { forgotEmail } from "../../api/action/user";

const ForgotEmail = (props) => {
  const [user, setUser] = useState({
    phoneNumber: "",
  });
  const [flag, setFlag] = useState(false);
  const [error, setError] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const nav = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "phoneNumber") {
      // Only allow numbers and limit the length to 10 digits
      const formattedValue = value.replace(/\D/g, "").slice(0, 10);
      const isValid = validator.isMobilePhone(formattedValue);
      setPhoneError(!isValid);
      setUser((val) => ({
        ...val,
        [name]: formattedValue,
      }));
    }
    if (!phoneError) {
      setIsDisabled(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props
      .forgotEmail(user)
      .then((res) => {
        if (res.message === "Sucessfully send message") {
          setFlag(true);
          setError("Email address has been sent to your phone number");
          setIsDisabled(true);
          setUser({ phoneNumber: "" });
        } else {
          setFlag(false);
          setError(res.message);
          setIsDisabled(true);
          setUser({ phoneNumber: "" });
        }
      })
      .catch((err) => {
        setFlag(false);
        setError(
          err.message === "Failed to fetch"
            ? "Backend is not running"
            : err.message
        );
      });
  };

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn) {
      nav("/products");
    }
  }, [nav]);

  const companyState = useSelector((state) => state.companyReducer.company);
  const logoUrl = companyState?.logoLocation;

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-md p-5 sm:p-6 bg-white rounded-md shadow-md">
        <div className="flex flex-col items-center mb-4">
          <img src={logoUrl} alt="logo" className="w-20 h-20" />
          <h1 className="text-xl font-semibold text-gray-800">Forgot Email</h1>
        </div>
        {flag ? (
          <p className="text-center text-green-500 mb-4">{error}</p>
        ) : (
          <p className="text-center text-red-500 mb-4">{error}</p>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="phoneNumber"
              className="block mb-1 text-sm font-medium text-gray-700"
            >
              Enter your registered phone number
            </label>
            <NumberFormat
              id="phoneNumber"
              type="tel"
              mask="_"
              className={`w-full px-4 py-3 lg:py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${phoneError ? "border-red-500" : "border-gray-300"
                }`}
              placeholder="e.g. 9876543210"
              name="phoneNumber"
              onChange={handleChange}
              value={user.phoneNumber}
              required
            />
            {phoneError && (
              <p className="mt-1 text-sm text-red-500">
                Please enter a valid phone number.
              </p>
            )}
          </div>
          <div>
            <button
              type="submit"
              disabled={isDisabled}
              className={`w-full py-3 lg:py-2 text-white font-bold rounded-md ${isDisabled
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
                }`}
            >
              Get Email
            </button>
          </div>
        </form>
        <div className="mt-4 text-center">
          <p>
            Back to{" "}
            <a
              href="/forgot-password"
              className="text-blue-600 hover:underline"
            >
              Forgot Password
            </a>
          </p>
        </div>
        <hr className="my-4" />
        <div className="text-center">
          <p>
            Or{" "}
            <a href="/sign-in" className="text-blue-600 hover:underline">
              Sign in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { isAuthenticated, user } = state?.auth?.data;
  return { isAuthenticated, user };
}

export default connect(mapStateToProps, { forgotEmail })(ForgotEmail);
